export default __webpack_public_path__ + "static/media/whatsapp-line.de0b985d.svg";